import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import Modal from "react-bootstrap/Modal";

// Strip HTML tags
const stripHtml = (html) => html.replace(/<[^>]*>?/gm, "");

// Truncate plain text
const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.slice(0, limit);
};

function VisionMissionValue({ principles, siteType, defaultHeadings = ["Vision:", "Mission:", "Values:"] }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");

  const CHAR_LIMIT = 67;

  if (!principles?.length || siteType !== "hospitals") return null;

  const handleReadMore = (description, heading) => {
    setSelectedContent(description);
    setSelectedTitle(heading);
    setShowModal(true);
  };

  const renderBox = (data, index, isMobile = false) => {
    const description = data?.description || "No Description Found";
    const plainText = stripHtml(description);
    const isTruncated = plainText.length > CHAR_LIMIT;
    const truncatedText = truncateText(plainText, CHAR_LIMIT);

    const contentToShow = isTruncated
      ? `${truncatedText}... <span class="theme-color p-0 ml-1 fw-bold" style="cursor:pointer ;">Read More</span>`
      : description;

    return (
      <div key={index} className={`${isMobile ? "item mb-3" : "col-md-4 my-4"}`}>
        <div className="feature-box-wrap f-box-style-1 relative animated fadeInDown">
          <div className="feature-box-details for-readmore text-center py-2">
            <div className="feature-icon">
              <img
                src={data?.image || "/assets/img/no-image.png"}
                alt=""
                style={{ width: "40px", height: "40px" }}
              />
            </div>
            <div className="feature-content">
              <div className="feature-title relative margin-bottom-10">
                <h5>{data?.heading || defaultHeadings[index]}</h5>
              </div>
              <p
                className="mb-0 text-black vision-description-color"
                dangerouslySetInnerHTML={{ __html: contentToShow }}
                onClick={(e) => {
                  if (e.target.innerText === "Read More") {
                    handleReadMore(description, data?.heading || defaultHeadings[index]);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
    <div className="container">

 
      {/* Desktop View */}
      <div className="home-intro-desktop mt-5">
        <div className="row">
          {principles?.map((data, index) => renderBox(data, index))}
        </div>
      </div>

      {/* Mobile View */}
      <div className="home-intro-mobile-view">
        <div className="row">
          <OwlCarousel
            className="service-main-wrapper"
            loop
            nav={false}
            dots={false}
            autoplay
            autoplayTimeout={2500}
            autoplayHoverPause
            smartSpeed={1000}
            margin={30}
            responsive={{ 0: { items: 1 } }}
          >
            {principles.map((data, index) => renderBox(data, index, true))}
          </OwlCarousel>
        </div>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: selectedContent }} />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
         </div>
    </>
  );
}

export default VisionMissionValue;
